<template>
  <v-container fluid>
    <page-header :menuItems="menuItems">
      Users
    </page-header>
    
    <v-sheet>
        <div v-if="users && users.length < 1">
          <span class="font-weight-medium">No data</span>
        </div>
        <v-data-table :search="true" :headers="userHeaders" :items="users" v-else>
          <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
        </template>
          <template v-slot:item.name="{ item }">{{item.firstName}} {{item.lastName}}</template>
          <template v-slot:item.locations="{ item }">
            <v-bottom-sheet>
              <template v-slot:activator="{ on, attrs }">
                <v-chip outlined v-bind="attrs" v-on="on">{{ item.locations ? item.locations.length:0}}</v-chip>
              </template>
              <v-sheet class="text-center" min-height="100px">
                <div style="overflow-x: scroll; white-space: nowrap;">
                  <span :key="l.id" v-for="l in item.locations">
                    <v-chip class="ma-5" outlined>{{l.name}}</v-chip>
                  </span>
                </div>
              </v-sheet>
            </v-bottom-sheet>
          </template>
          <template v-slot:item.action="{ item }">
            <!-- <edit-administrator :locations="account.locations" :administrator.sync="item" /> -->

            <v-btn :to="{name: 'User', params: {id: item.id} }" icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn @click="deleteAdmin(item)" icon>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import PageHeader from '../components/common/PageHeader.vue';

export default {
  data() {
    return {
      users: [],
      userHeaders: [
        { text: "Name", value: "name", align: "start", sortable: false },
        {
          text: "Username",
          value: "username",
          align: "start",
          sortable: false,
        },
        { text: "Email", value: "email", align: "start", sortable: false },
        { text: "Phone", value: "phone", align: "start", sortable: false },
        {
          text: "Locations",
          value: "locations",
          align: "start",
          sortable: false,
        },
        { text: "Action", value: "action", align: "start", sortable: false },
      ],
      menuItems: [
      {
          id: "new-user",
          text: "New User",
          icon: "mdi-account-add",
          to: {name: 'User'}
        },
    ],
    };
  },
  components: {
    // EditAdministrator: () => import("@/components/EditAdministrator.vue"),
    PageHeader,
  },
  computed: 
  {
    ...mapGetters(["navState", "isAppLoading", "globalCenter"]),
  },
  filters: {
    formateDate(value) {
      return moment(value).format("MMMM Do YYYY, h:mm a");
    },
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    async initAccountUsers() {
      return await this.$axios
        .get("/account/get-users")
        .then((resp) => {
          return resp.data;
        })
        .catch((error) => {
          this.addErrorMessage(error.data.message || "Error loading users from server");
        });
    },
    deleteAdmin(admin){
      if(confirm(`Confirm delete ${admin.firstName}?`)){
        this.$axios
        .delete("/account/admin/delete", { params: {adminUserId: admin.id}})
        .then( () => {
          this.users.splice(this.users.findIndex(a => a.id == admin.id), 1);
        })
        .catch((error) => {
          console.log(error)
          this.addErrorMessage("Error deleting admin from server");
        });
      }
    },
  },
  created() {
    this.initAccountUsers()
      .then((users) => {
        this.users = users;
      })
  },
};
</script>